import type { ElementType, ReactNode } from "react";

export function Eyebrow({
  as: Tag = "p",
  className = "",
  children,
}: {
  as?: ElementType;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Tag
      className={`font-editorial text-xs font-semibold tracking-[0.18em] text-gold-deep uppercase ${className}`.trim()}
    >
      {children}
    </Tag>
  );
}
